import React from 'react';
import { TestIdIdentifier } from '../../../../../util/identifiers/identifiers.util';
import { FooterButton } from '../../Button/Button';
import ModalFooter from './ModalFooter';

interface ModalPaneProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
  footerButtons?: FooterButton[];
  overflow?: 'visible' | 'auto' | 'hidden';
  testId?: TestIdIdentifier;
  contentPadding?: string;
}

export default function ModalPane({
  children,
  footer,
  footerButtons,
  overflow = 'visible',
  testId,
  contentPadding = 'p-6',
}: ModalPaneProps) {
  return (
    <div className='flex h-full flex-col' data-testid={testId?.name}>
      <div className={`flex-grow ${contentPadding}`} style={{ overflow }}>
        {children}
      </div>

      {footer || footerButtons?.length ? <ModalFooter children={footer} buttons={footerButtons} /> : null}
    </div>
  );
}
